// extracted by mini-css-extract-plugin
export default {"Title":"CC71mtx3V7hACD0nItHL"};